import { render, staticRenderFns } from "./PostContentField.vue?vue&type=template&id=07d2bbec&scoped=true&"
import script from "./PostContentField.vue?vue&type=script&lang=js&"
export * from "./PostContentField.vue?vue&type=script&lang=js&"
import style0 from "./PostContentField.vue?vue&type=style&index=0&id=07d2bbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d2bbec",
  null
  
)

export default component.exports